import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import FilledLatestAnnouncementIcon from "@/Components/Icons/FilledLatestAnnouncementIcon";
import LatestAnnouncementIcon from "@/Components/Icons/LatestAnnouncementIcon";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import {
  toggleViewMoreAnnuouncementModal,
  updateClickAnnouncementId,
} from "@/reducers/clientAnnouncement";
import { formatLatestUpdateForAnnouncement } from "@/utilities/utils";

const ViewMoreOneAnnouncementModal = () => {
  const {
    showViewMoreAnnuouncementModal,
    clientAnnouncements,
    clickViewMoreAnnouncementId,
  } = useSelector((state) => state.clientAnnouncement);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(toggleViewMoreAnnuouncementModal(false));
    setTimeout(() => {
      dispatch(updateClickAnnouncementId(""));
    }, 200);
  };

  const clientAnnouncementId =
    clientAnnouncements.find(
      (candidate) => candidate.announcement_id == clickViewMoreAnnouncementId,
    ) || {};

  const {
    announcement_title,
    announcement_ref_no,
    announcement_message,
    created_at,
  } = clientAnnouncementId || {};

  return (
    <ModalPopUp
      show={showViewMoreAnnuouncementModal}
      panelClass="max-w-[770px] max-sm:max-w-[400px]"
      // onClose={handleClose}
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            Announcement
          </h3>
          <button
            onClick={handleClose}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div className="group flex w-fit items-center gap-3">
          <div className="rounded-lg bg-grey p-2 transition-all duration-300 group-hover:bg-primary">
            <LatestAnnouncementIcon
              cls={`h-[24px] w-[24px] text-primary  group-hover:hidden`}
            />
            <FilledLatestAnnouncementIcon
              cls={`pr-[3.5px] h-[24px] w-[24px] hidden group-hover:block !text-white`}
            />
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-Base text- line-clamp-1 font-semibold capitalize">
              {/* {announcement_title} */}
              {moment(created_at).format("LL")}
            </p>
            <p className="text-[14px] font-medium leading-[normal] text-txtColor">
              {announcement_ref_no}
            </p>
          </div>
        </div>

        <div className="SubBranchescustom-scrollbar-ui max-h-[400px] w-full overflow-y-auto">
          <div
            className="ml-1 text-[16px] font-normal leading-[normal] text-black"
            dangerouslySetInnerHTML={{
              __html: formatLatestUpdateForAnnouncement(
                announcement_message || "",
              ),
            }}
          />
        </div>
      </div>
    </ModalPopUp>
  );
};

export default ViewMoreOneAnnouncementModal;
